import PropTypes from 'prop-types'
import RadioInput from './RadioInput'
import NumberInput from './NumberInput'
import RangeInput from './RangeInput'
import ChooseInput from './ChooseInput'
import TextInput from './TextInput'
import AttachmentInput from './AttachmentInput'
import CodeInput from './CodeInput'

function QuestionInput({ question, value, onChange, onUploading }) {
  switch (question.answerType) {
    case 'radio':
      return <RadioInput value={value} onChange={onChange} />
    case 'number':
      return <NumberInput value={value} onChange={onChange} />
    case 'range':
      return <RangeInput value={value} onChange={onChange} />
    case 'choose':
      return (
        <ChooseInput question={question} value={value} onChange={onChange} />
      )
    case 'text':
      return <TextInput value={value} onChange={onChange} />
    case 'attachment':
      return (
        <AttachmentInput
          value={value}
          onChange={onChange}
          onUploading={onUploading}
        />
      )
    case 'code':
      return <CodeInput value={value} onChange={onChange} />
    default:
      return <TextInput value={value} onChange={onChange} />
  }
}

QuestionInput.propTypes = {
  question: PropTypes.shape({
    answerType: PropTypes.string.isRequired,
    answer: PropTypes.shape({
      options: PropTypes.objectOf(PropTypes.string),
    }),
  }).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({}),
  ]),
  onChange: PropTypes.func.isRequired,
  onUploading: PropTypes.func,
}

export default QuestionInput
